module.exports = __webpack_public_path__ + "img/logo.79b10e81.png";